import { getAnalysisInitialState } from '@modules/analysis/store/getAnalysisInitialState';
import { AnalysisStoreOptions } from '@modules/analysis/store/types';
import { AnalysisUseCase } from 'generated/graphql';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface CreateAnalysisStoreArgs {
  useCase: AnalysisUseCase;
}

export const createAnalysisStore = ({ useCase }: CreateAnalysisStoreArgs) =>
  create<AnalysisStoreOptions, [['zustand/devtools', never]]>(
    devtools((set) => getAnalysisInitialState(set, useCase), {
      name: 'AnalysisStore',
    }),
  );
